export const appTypeList = [
  { label: 'Android', value: 1 },
  { label: 'IOS', value: 2 },
  { label: '鸿蒙', value: 3 },
  { label: '其它', value: 4 }
]

export const appTypeMap = {
  1: 'Android',
  2: 'IOS',
  3: '鸿蒙',
  4: '其他'
}
